import { locationListActions } from "./actions";

const initialState = {
    locationData: [],
    cityList:[],
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case locationListActions.CITY_LIST:
      return {
        ...state,
        cityList: action.payload.data,
      };
      case locationListActions.CITY_LIST_ERROR:
      return {
        ...state,
        cityList: [],
      };
    

    default:
      return state;
  }
};

export default locationReducer;
